import React, { useState } from 'react';

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import NavBarMenu from '../NavBarMenu';
import FooterMenu from '../FooterMenu';
import PerformanceAppPlanMetrics from '../tables/performanceAppPlanMetrics';
import PerformanceDatabaseMetrics from '../tables/performanceDatabaseMetrics';
import { Tab, Tabs } from 'react-bootstrap';

function Metrics() {

    const [activeTab, setActiveTab] = useState("appPlans");
    const [refreshTrigger, setRefreshTrigger] = useState(0);

    const handleTabChange = (tabKey) => {
        setActiveTab(tabKey);
        setRefreshTrigger(prev => prev + 1); 
    };

    const [value, setValue] = useState(30);
      const handleChanges = (newValue) => {
          setValue(newValue) 
    }
  
    const [instance, setInstance] = useState();
    const handleInstanceChanges = (newInstance) => {
        setInstance(newInstance) 
    }

    return (
      <>
        <NavBarMenu handleInstanceChanges={handleInstanceChanges} handler={handleChanges} />
        <main>
            <Container fluid>
            <Row className="display-flex">
                <Col >     
                    <Tabs
                        defaultActiveKey="appPlans"
                        activeKey={activeTab}
                        onSelect={handleTabChange}
                        id="metricTab"
                        className="mb-3"
                    >
                        <Tab eventKey="appPlans" title="Application Services">
                            <PerformanceAppPlanMetrics refreshTrigger={refreshTrigger}/>
                        </Tab>
                        <Tab eventKey="databases" title="Databases">
                            <PerformanceDatabaseMetrics refreshTrigger={refreshTrigger}/>
                        </Tab>
                    </Tabs>
                </Col>
            </Row>
            </Container>
        </main>
        <FooterMenu />
      </>
    );
}
export default Metrics